export let savedCards = [
    { id: "saved_card_1", number: "9824" },
    { id: "saved_card_2", number: "0167" },
];
export let authQuestions = [
    {
        question: "Will you be connecting to one of your databases?",
        options: [
            "Yes I’ll connect",
            "No, Not Interested",
        ],
        image: "/images/auth/auth-question-1.png",
    },
    {
        question: "What are you primarily interested in doing?",
        options: [
            "Dashboard Design",
            "Low-code (Excel-like) analysis",
            "Full DBA/Developer usage",
        ],
        image: "/images/auth/auth-question-2.png",
    },
];
